<template>
  <v-dialog width="500px" :value="value" @input="toggleModal" persistent scrollable >
    <v-card class="kbLight">
      <div class="d-flex align-center justify-center kbWhite"
           style="height: 250px; box-shadow: -2px -2px 6px 0 rgba(0, 0, 0, 0.2); position: relative">
        <v-img src="https://storage.googleapis.com/keybe/images/kb-logos/keybe-light.svg"
               style="max-width: 180px">
        </v-img>
        <v-btn icon
               @click="toggleModal(false)"
               style="position: absolute; right: 10px; top: 10px;">
          <v-icon>clear</v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-container class="pa-0" fluid>
          <v-row class="py-4"  v-if="loadingUser" justify="center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              {{ $t('general.onetimePasswordUse') }}
            </v-col>

            <v-col cols="12" v-if="selectedUser.email">
                <v-checkbox v-model="sendMail"
                            color="kbPink"
                            hide-details
                            :label="$t('general.sendToPersonEmail')"/>
            </v-col>

            <v-col cols="12" v-if="selectedUser.phone">
                <v-checkbox v-model="sendPhone"
                            color="kbPink"
                            hide-details
                            :label="$t('general.sendToPersonPhone')"/>
            </v-col>

            <v-col cols="12">
              <v-row class="py-2 px-4"  align="center" justify="space-between">
                <v-btn style="text-transform: none"
                       rounded
                       color="kbPink"
                       dark
                       :loading="generatingOneTimePassword"
                       @click="generateOneTimePassword">{{ $t('general.generatePassword') }}</v-btn>
                <transition name="fade">
                  <v-btn style="text-transform: none"
                         rounded
                         color="kbPink"
                         dark
                         @click="copyOneTimePassword" v-if="oneTimePassword">
                    {{ $t('general.password') }}: {{oneTimePassword}}
                    <v-icon right small dark>file_copy</v-icon>
                  </v-btn>
                </transition>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" outlined @click="toggleModal(false)">{{ $t('general.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  computed: {
    ...mapState({
      loadingUser: state => state.users.loadingUser,
      selectedUser: state => state.users.selectedUser
    })
  },
  data () {
    return {
      displayCopyPasswordBtn: false,
      generatingOneTimePassword: false,
      oneTimePassword: '',
      sendMail: false,
      sendPhone: false
    }
  },
  methods: {
    copyOneTimePassword () {
      navigator.clipboard.writeText(this.oneTimePassword).then(() => {
        notifications.success(this.$t('general.passwordCopiedToClipboard'))
      }).catch(() => {
        notifications.error(this.$t('general.errorCopyingThePassword'))
      })
    },
    generateOneTimePassword () {
      this.generatingOneTimePassword = true
      this.$store.dispatch('generateOneTimePassword', { sendMail: this.sendMail, sendPhone: this.sendPhone })
        .then(response => {
          notifications.success(response.message)
          if (response.password.length === 4) {
            this.oneTimePassword = response.password
          }
          this.generatingOneTimePassword = false
        })
        .catch(error => {
          console.log(error)
          this.generatingOneTimePassword = false
        })
    },
    toggleModal (value) {
      this.oneTimePassword = ''
      this.sendMail = false
      this.sendPhone = false
      this.$emit('input', value)
    }
  },
  props: ['value']
}
</script>
